import { createContext, useContext } from "react";
import { message } from "antd";

const ToastContext = createContext(null);

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const showToast = (type, content) => {
    messageApi.open({
      type,
      content,
    });
  };

  const toast = {
    success: (msg) => showToast("success", msg),
    error: (msg) => showToast("error", msg),
    warning: (msg) => showToast("warning", msg),
    info: (msg) => showToast("info", msg),
  };

  return (
    <ToastContext.Provider value={toast}>
      {contextHolder}
      {children}
    </ToastContext.Provider>
  );
};
